import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {Token} from '../jwt/token';
import {first, map} from 'rxjs/operators';
import * as uuid from 'uuid';
import {SEGURANCA_CONFIGURATION, SegurancaConfiguration} from '../http-interceptor/credentials-interceptor/credentials-interceptor.service';

export const TKN = 'mcltkn';
export const DEV = 'mcluid';

interface SessaoDTO {
  token?: Token;
  usuario?: any;
}

export interface ComunicacaoHttpSessao {
  refresh(token: string): Promise<SessaoDTO>;

  logout(): Promise<void>;
}

@Injectable({
  providedIn: 'root'
})
export class SessaoService {

  private comunicacao: ComunicacaoHttpSessao;
  private $sessao = new ReplaySubject<SessaoDTO>(1);

  constructor(@Inject(SEGURANCA_CONFIGURATION) private segurancaConfig: SegurancaConfiguration) {
  }

  private loadToken(): string {
    return localStorage.getItem(this.segurancaConfig.tokenStorageName || TKN);
  }

  private saveToken(token: string) {
    if (token) {
      localStorage.setItem(this.segurancaConfig.tokenStorageName || TKN, token);
    } else {
      localStorage.removeItem(this.segurancaConfig.tokenStorageName || TKN);
    }
  }

  async init(comunicacao: ComunicacaoHttpSessao) {
    this.comunicacao = comunicacao;

    const token = this.loadToken();

    if (token) {
      try {
        await this.refresh(token);
      } catch (ex) {
        console.log(ex);
        this.$sessao.next({});
      }
    } else {
      this.$sessao.next({});
    }

    this.token.subscribe((tkn) => {
      this.saveToken(tkn && tkn.raw);
    });

    setInterval(async () => {
      const tkn = await this.token.pipe(first()).toPromise();
      if (!!tkn) {
        try {
          await this.refresh(tkn.raw);
        } catch (ex) {
          console.log(ex);
        }
      }
    }, 60000);
  }

  private async refresh(token: string) {
    const sessao = await this.comunicacao.refresh(token);

    console.log('refresh end');
    this.$sessao.next(sessao);
  }

  get usuario(): Observable<any> {
    return this.$sessao.asObservable().pipe(map(sessao => sessao.usuario));
  }

  get token(): Observable<Token> {
    return this.$sessao.asObservable().pipe(map(sessao => sessao.token));
  }

  get autenticado(): Observable<boolean> {
    return this.$sessao.asObservable().pipe(map(sessao => !!sessao.token));
  }

  get device(): string {
    let dev = localStorage.getItem(DEV);

    if (!dev) {
      dev = uuid.v4();

      localStorage.setItem(DEV, dev);
    }

    return dev;
  }

  login(sessao: SessaoDTO): any {
    this.$sessao.next(sessao);

    return sessao.usuario;
  }

  async logout(): Promise<any> {
    try {
      await this.comunicacao.logout();
    } finally {
      this.$sessao.next({});
    }
  }

}
